
import React, { useState, useEffect } from "react";
import "./msr.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useDispatch } from "react-redux";
import { MsrIsActiveViewAction, MsrListAction } from "../../actions/msrAction";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { notify } from '../../services/notification';
import { dowloadmsrlistAction } from "../../actions/msrAction";
import { encode } from "base-64";
import { UpdateMsrAction } from "../../actions/msrAction";
import { HiMenu, HiX } from "react-icons/hi";
import { constant } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";
import ConfirmationPopup from "../../component/ConfirmationPopup";


function Msr() {
  const [isLoading, setLoading] = useState(false);
  const [criteria, setcriteria] = useState("");
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const [msrNamesList, setMsrNamesList] = useState([]);
  const [paginationListcount, setpaginationListcount] = useState(0);
  const [count, setCount] = useState(1);

  const [page, setPage] = useState(1);
  const [searchvalue, setSearchValue] = useState("");
  const [currentStatusId, setCurrentStatusId] = useState("");
  const [currentStatusValue, setCurrentStatusValue] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);

  const dispatch = useDispatch();

  async function handleCriteriaChange(event) {
    setcriteria(event.target.value)
  }

  async function handleSearchChange(event) {
    setSearchValue(event.target.value)
    if (event.target.value === "") {
      window.location.reload();
    }
  }

  async function GetMsrNameListData(pageNumber, query) {
    setLoading(true);
    var response = await dispatch(MsrListAction(pageNumber, constant.paginationCount, query));
    if (response?.status === 200) {
      setLoading(false);
      setMsrNamesList(response?.data?.results?.data);
      setpaginationListcount(response.data.count)
      setCount(Math.ceil(response.data.count / constant.paginationCount))

    }
  }

  const search = () => {
    let query = `&${criteria}=${searchvalue}`
    GetMsrNameListData(1, query);
  }

  const CreateUser = (evt) => {
    navigate('/createmsr')
  }

  const navigate = useNavigate();


  useEffect(() => {
    GetMsrNameListData(1)
  }, []);




  const UpdateMsr = (id) => {
    window.scroll(0, 0);
    const encodeid = encode(id);
    navigate(`/editmsr/${encodeid}`);
  }

  const handlePageChange = (event, value) => {
    setPage(value);
    GetMsrNameListData(value)
  };

  const handleOpenStatusConfirmationModal = (id, checked) => {
    setCurrentStatusId(id);
    setCurrentStatusValue(checked);
    setOpenStatusModal(true);
  };

  const handleCloseStatusConfirmationModal = () => {
    setCurrentStatusId("");
    setCurrentStatusValue(false);
    setOpenStatusModal(false);
  };

  const handleStatusConfirmation = async () => {
    await handleOnActiveClick(currentStatusId, currentStatusValue ? "true" : "false");

    // Update the local state to reflect the change
    const newData = msrNamesList.map(item => {
      if (item.id === currentStatusId) {
        return { ...item, is_active: currentStatusValue };
      }
      return item;
    });
    setMsrNamesList(newData);

    handleCloseStatusConfirmationModal();
    await GetMsrNameListData(page);
  };

  const handleCheckboxChange = (id, checked) => {
    handleOpenStatusConfirmationModal(id, checked);
  };

  const handleOnActiveClick = async (id, data) => {
    const apiReq = {
      is_active: data
    }
    setLoading(true);
    let response = await dispatch(MsrIsActiveViewAction(apiReq, id));
    if (response?.status === 200) {
      notify.success(response.data.message);
      setLoading(false);
      window.scroll(0, 0);
    } else {
      setLoading(false);
      notify.error(response.data.message);
    }
  }
  async function downloadmsrlist() {
    try {
      let query = `&${criteria}=${searchvalue}`
      const fileBlob = await dispatch(dowloadmsrlistAction(1, query));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl , '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const startItem = msrNamesList?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  return (
    <div className="msr-container">
      <div className="msr-right-sidebar">
        <Header title="MSR" />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="msr-first-collumn">
            <div className="Final">
              <div className="msrs">
                <div className="msr">
                  <select className="msr-fields-dropdowns" value={criteria} onChange={handleCriteriaChange}>
                    <option value="">Select Criteria</option>
                    <option value="name">MSR Name</option>
                    <option value="mobile_number">Mobile Number</option>
                    <option value="msr_id">MSR Id</option>
                  </select>
                  <input
                    type="search"
                    className="msr-search-input"
                    placeholder="Enter a Value"
                    name="nameValue"
                    value={searchvalue}
                    onChange={handleSearchChange}
                  />
                  <button className="search-msr" type="button" onClick={search}>Search</button>
                </div>
                <div className="msr-button">
                  <button
                    type="button"
                    className="create-msr"
                    onClick={CreateUser}
                  >
                    Create MSR +
                  </button>
                  <button className="download-excel-button" onClick={downloadmsrlist}>
                    <img src={Image_Url.EXCEL_LOGO} className="download-excel-icon" />
                    Download Excel
                  </button>
                </div>
              </div>
            </div>
            {msrNamesList?.length > 0 ?
              <div className="table-data">

                <table className="table">
                  <tr className="tablesth">
                    <th>Name</th>
                    <th>MSR Id</th>
                    <th>Phone Number</th>
                    <th>Address</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  {msrNamesList.map((data, index) => (
                    <tr className="tabletd">
                      <td>{data?.name}</td>
                      <td>{data?.msr_id}</td>
                      <td>{data?.mobile_number}</td>
                      <td>{data?.address}</td>
                      <td>{data?.is_active === false ? "Deactivated" : "Activated"}</td>
                      <td className="tabletdV">
                        <div className="edit-icons">
                          <img
                            src={Image_Url.EDIT}
                            className="editicons"
                            onClick={() => UpdateMsr(data?.id)}
                          />
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={data.is_active}
                              onChange={(e) => handleCheckboxChange(data?.id, e.target.checked)}
                            />
                            <span className="slider round"></span>
                          </label>

                        </div>
                      </td>
                    </tr>
                  ))}
                </table>


              </div>
              : <NoDataFound />}
            <div className="Pagination_section">
              <Stack spacing={2}>
                <Pagination
                  count={count}
                  className="pagination"
                  page={page}
                  size="medium"
                  defaultPage={1}
                  color="primary"
                  onChange={handlePageChange}
                />
              </Stack>
              <div className="count">
                <b>
                  <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                </b>
              </div>
            </div>
          </div>
        )}
      </div>
      <ConfirmationPopup
        openDeleteModal={openStatusModal}
        handleOnDeleteClick={handleStatusConfirmation}
        handleCloseDeleteConfirmationModal={handleCloseStatusConfirmationModal}
        messageHeading={"WARNING!"}
        messageBody={`Are you sure you want to ${currentStatusValue ? "activate" : "deactivate"} this MSR?`}
        isLoading={isLoading}
      />
    </div>
  );
}

export default Msr;